/* eslint-disable @typescript-eslint/no-unused-vars */
import Vue from 'vue';

const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;
const MONTH = DAY * 30;
const YEAR = MONTH * 12;
const IN_MILLISECONDS = 1000;

export default function SecsToTimeString(timeInSecs: number, shortText = false, hoursOnly = false) {
    const secs = Math.floor(timeInSecs % MINUTE);
    const minutes = Math.floor((timeInSecs % HOUR) / MINUTE);
    const hours = Math.floor((timeInSecs % DAY) / HOUR);
    const days = Math.floor(timeInSecs / DAY);

    let ss = '';
    if (days) ss = ss + days + (shortText ? 'd' : ' Day(s) ');
    if (hours || hoursOnly) ss = ss + hours + (shortText ? 'h' : ' Hour(s) ');
    if (!hoursOnly) {
        if (minutes) ss = ss + minutes + (shortText ? 'm' : ' Minute(s) ');
        if (secs || (!days && !hours && !minutes)) {
            ss = ss + secs + (shortText ? 's' : ' Second(s).');
        }
    }

    return ss;
}

Vue.filter('secsToTimeString', function(value: number, shortText: boolean, hoursOnly: boolean) {
    return SecsToTimeString(value, shortText, hoursOnly);
});
